import React from 'react';

import { ContentSwitcher } from '@xingternal/content-switcher';
import type {
  ContentSwitcherProps,
  ContentSwitcherDataProps,
} from '@xingternal/content-switcher';

import { Styled } from './SubpageNavigation.styles';

type SubpageNavigationProps = {
  noPadding: boolean;
  data: ContentSwitcherDataProps[];
} & ContentSwitcherProps;
const SubpageNavigation: React.FunctionComponent<SubpageNavigationProps> = ({
  noPadding,
  data,
  ...props
}) => (
  <Styled.StyledContainer $noPadding={noPadding}>
    <ContentSwitcher data={data} {...props} />
  </Styled.StyledContainer>
);

export default SubpageNavigation;
